import { render, staticRenderFns } from "./RemoveFromListButton.vue?vue&type=template&id=ba519cfa&"
import script from "./RemoveFromListButton.vue?vue&type=script&lang=js&"
export * from "./RemoveFromListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports